import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import { DeleteEntityModal as _DeleteEntityModal } from "routes/entity/components/Modals";
import { useEntityNavigation } from "routes/entity/useEntityNavigation";

const EDIT_ACLS = [ACL_RELATIONSHIPS.entity.edit, ACL_RELATIONSHIPS.user.read];

const DeleteEntityModal = withRoleCheck(_DeleteEntityModal, [
  ACL_RELATIONSHIPS.entity.delete,
]);

export const EntityTableActions = ({ entityId, onConfirmDelete }) => {
  const { openEdit } = useEntityNavigation();

  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        <Authorized permissions={EDIT_ACLS}>
          <Dropdown.Item
            icon="edit"
            content="Edit"
            onClick={() => openEdit(entityId)}
          />
        </Authorized>
        <DeleteEntityModal
          onConfirmDelete={() => onConfirmDelete(entityId)}
          menuTrigger
        />
      </Dropdown.Menu>
    </CustomDropdown>
  );
};
